import React, { Fragment } from 'react';
import styled from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button';
import MediaPopupProvider from 'gatsby-theme-core/src/components/media-popup/provider';
import useMediaPopup from 'gatsby-theme-core/src/components/media-popup/use-media-popup';
import MediaPopup from 'gatsby-theme-core/src/components/media-popup/index';
import Image from 'gatsby-theme-core/src/components/image';
import GalleryIcon from 'icons/src/Gallery';
import { usePreview } from '../provider';
import Link from './link';

const GalleryOpenButton = styled((props) => {
  const { setImagesOpen } = useMediaPopup();
  return (
    <Button
      {...props}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setImagesOpen(true);
      }}
    />
  );
}).attrs({ wrapper: true })`
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.8rem;
  background-color: white;
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    padding: 0.5rem;
  }
`;

const Overlay = styled(Image)`
  position: absolute !important;
  top: 0;
  left: 0;
`;

const PreviewImageComponent = ({
  className,
  withLink,
  withMediaPopup = false,
  append = null,
  ...props
}) => {
  const { vdp, image, name } = usePreview();
  const { useImageOverlays } = vdp;
  const Wrapper = withLink ? Link : Fragment;
  return (
    <Wrapper>
      <Image
        {...props}
        className={className}
        image={image}
        options={[]}
        alt={name}
      />
      {image?.overlay && useImageOverlays !== false && (
        <Overlay
          {...props}
          loading="eager"
          className={className}
          image={image.overlay}
          options={[]}
          alt=""
        />
      )}
      {append}
      {withMediaPopup && withLink && (
        <GalleryOpenButton>
          <GalleryIcon />
        </GalleryOpenButton>
      )}
    </Wrapper>
  );
};

const PreviewImage = (props) => {
  const {
    images,
  } = usePreview();
  if ((images || []).length === 0) {
    return (
      <PreviewImageComponent {...props} />
    );
  }
  return (
    <MediaPopupProvider>
      <MediaPopup
        imageSlides={images.map((image) => ({ image }))}
      />
      <PreviewImageComponent withMediaPopup {...props} />
    </MediaPopupProvider>
  );
};

export default styled(PreviewImage)`
  display: block !important;
  max-width: 100%;
  height: auto;
`;
